import React, { forwardRef } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import classNames from 'classnames';
import { HiChevronDown } from 'react-icons/hi';
import { StyledAccordionTrigger } from './styleGuide';

// eslint-disable-next-line react/display-name
const AccordionItem = forwardRef(({ children, className, ...props }: any, forwardedRef) => (
  <Accordion.Item
    className={classNames(
      'mt-px overflow-hidden first:mt-0 first:rounded-t last:rounded-b focus-within:relative focus-within:z-10',
      className
    )}
    {...props}
    ref={forwardedRef}
  >
    {children}
  </Accordion.Item>
));

// eslint-disable-next-line react/display-name
const AccordionTrigger = forwardRef(({ children, className, textColor, ...props }: any, forwardedRef) => (
  <Accordion.Header className="flex">
    <StyledAccordionTrigger
      $textColor={textColor}
      className={classNames(
        'group flex h-[70px] flex-1 cursor-default items-center justify-between bg-white px-5 text-[15px] leading-none shadow-[0_1px_0] shadow-mauve6 outline-none hover:bg-mauve2 focus:outline-none focus-visible:outline-none focus-visible:ring-0',
        className
      )}
      {...props}
      ref={forwardedRef}
    >
      {children}
      <p
        style={{ color: textColor }}
        className="transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=open]:rotate-180"
        aria-hidden
      >
        <HiChevronDown size={24} />
      </p>
    </StyledAccordionTrigger>
  </Accordion.Header>
));

// eslint-disable-next-line react/display-name
const AccordionContent = forwardRef(({ children, className, ...props }: any, forwardedRef) => (
  <Accordion.Content
    className={classNames(
      'overflow-hidden bg-mauve2 text-[15px] text-mauve11 data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown',
      className
    )}
    {...props}
    ref={forwardedRef}
  >
    <div className="px-5 py-[15px]">{children}</div>
  </Accordion.Content>
));

export { AccordionItem, AccordionTrigger, AccordionContent };
